import React, { Component } from "react";
import { Input } from "../../forms/input";
import Signbutton from "../../forms/button";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import { connect } from "react-redux";
import CustomizedSelect from "./customizedSelect";
import MenuItem from "@material-ui/core/MenuItem";
import {
  getNewPurchaseFundList,
  validateSubBroker,
  getInvestorDetails,
  submitPurchaseData,
  showPurchaseConfirmation,
} from "../../../store/actions";
import {
  GET_FUNDS_LIST,
  GET_FUNDS_LIST_SUCCESS,
  GET_FUNDS_LIST_FAILED,
  GET_CATEGORY_LIST,
  GET_CATEGORY_LIST_SUCCESS,
  GET_SCHEME_LIST,
  GET_SCHEME_LIST_SUCCESS,
  GET_CATEGORY_LIST_FAILED,
  GET_SCHEME_LIST_FAILED,
  PURCHASE,
  ALL,
  REGULAR,
  NO,
  YES,
  NEW_PURCHASE,
  REQ_BY,
  singleTransaction,
  SUBMIT,
  addToCart,
} from "../../../store/types";
import { Checkbox } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import { NEW_TRANSACTION_URL } from ".";
import CustomLoader from "../../forms/Loader";
import { family_description_code } from "../../forms/content";
import { AddToCartStatusModal, NewPurchaseFolioDialog } from "../customModal";

class NewPurchase extends Component {
  constructor(props) {
    super(props);
    const { fundList, location } = this.props;
    const { state } = location;
    const { transaction } = state;
    const funds = fundList.reduce((prev, curr) => {
      if (curr.pFlag === YES) {
        const findIndex =
          prev.findIndex((fund) => fund.Fund === curr.Fund) !== -1;
        if (!findIndex) {
          return [
            ...prev,
            { Fund: curr.Fund, FundDesc: curr.FundDesc, Folio: curr.Acno },
          ];
        }
      }
      return prev;
    }, []);

    const { investorData, communicationDetails = [], token } = this.props;
    const revCD =
      !!communicationDetails && communicationDetails.length > 0
        ? communicationDetails.reverse()
        : "";
    const Xmobile = (revCD || []).find(
      (detail) => detail.PAN === investorData.PAN && !!detail.Mobile
    );
    const Xemail = (revCD || []).find(
      (detail) => detail.PAN === investorData.PAN && !!detail.email
    );
    const Email = !!Xemail && !!Xemail.email ? Xemail.email : "";
    const Mobile = !!Xmobile && !!Xmobile.Mobile ? Xmobile.Mobile : "";
    const emailrelationshipvalue = !!transaction
      ? transaction.emailrelationship
      : "";
    const mobilerelationshipvalue = !!transaction
      ? transaction.mobilerelationship
      : "";
    const findEmailRelationship = family_description_code.find(
      (item) => item.family_code === emailrelationshipvalue
    );
    const EmailRelationship_label = !!findEmailRelationship
      ? findEmailRelationship.family_description
      : "";
    const findMobileRelationship = family_description_code.find(
      (item) => item.family_code === mobilerelationshipvalue
    );
    const MobileRelationship_label = !!findEmailRelationship
      ? findMobileRelationship.family_description
      : "";
    this.state = {
      funds,
      open: false,
      existingfolioflag: "",
      messageAlert: "",
      emailId: { value: !!transaction ? transaction.email : Email || "" },
      mobile: { value: !!transaction ? transaction.mobile : Mobile || "" },
      arnCode: { value: token },
      invName: {
        value: !!transaction
          ? transaction.InvName
          : this.props.investorData.invname || "",
      },
      fund: {
        value: !!transaction
          ? { label: transaction.fund, value: transaction.fund_code }
          : "",
      },
      category: { value: !!transaction ? transaction.Category : "" },
      scheme: {
        value: !!transaction
          ? {
              label: transaction.scheme_descrption,
              value: transaction.scheme_value,
            }
          : "",
      },
      minAmount: { value: !!transaction ? transaction.amount : "" },
      subArnCode: { value: !!transaction ? transaction.Sub_ARN_code : "" },
      euinNo: {
        value:
          !!transaction && transaction.euinopt == "N"
            ? transaction.euin_code
            : "",
      },
      radioValue: {
        value: ""//!!transaction && transaction.euinopt === "Y" ? "yes" : "no",
      },
      subBrokerCode: { value: !!transaction ? transaction.subbroker : "" },
      isCombo: false,
      combo: { flag: "", disclamier: "", label: "" },
      showSmart: false,
      smart: { flag: "yes" },
      PosterOpen: false,
      display: false,
      code: { value: "+91" },
      openeuin: true,
      radioValueforpayment: { value: "no" },
      reference_Number: { value: "" },
      erroreuin: false,
      Family_Code_Email: {
        value: !!transaction
          ? {
              label: EmailRelationship_label,
              value: transaction.emailrelationship,
            }
          : "",
      },
      Family_Code_Phone: {
        value: !!transaction
          ? {
              label: MobileRelationship_label,
              value: transaction.mobilerelationship,
            }
          : "",
      },
    };
  }

  async componentDidMount() {
    this.setState({
      display: true,
    });
    const params = {
      opt: ALL,
      schemetype: this.props.userId,
    };
    const types = [
      GET_FUNDS_LIST,
      GET_FUNDS_LIST_SUCCESS,
      GET_FUNDS_LIST_FAILED,
    ];
    await this.props.getNewPurchaseFundList(params, types);

    if (!!this.props.location.state.transaction) {
      const payload = {
        PAN: this.props.location.state.pan,
        Uid: this.props.userId,
        ReqBy: REQ_BY,
      };
      await this.props.getInvestorDetails(payload);

      let params = {
        plntype: REGULAR,
        opt: "AT",
        fund: !!this.props.location.state.transaction
          ? this.props.location.state.transaction.fund_code
          : "",
      };
      const types = [
        GET_CATEGORY_LIST,
        GET_CATEGORY_LIST_SUCCESS,
        GET_CATEGORY_LIST_FAILED,
      ];
      await this.props.getNewPurchaseFundList(params, types);
      let params1 = {
        plntype: REGULAR,
        opt: "S",
        schemetype: this.state.category.value,
        fund: this.state.fund.value.value,
      };
      const types1 = [
        GET_SCHEME_LIST,
        GET_SCHEME_LIST_SUCCESS,
        GET_SCHEME_LIST_FAILED,
      ];
      await this.props.getNewPurchaseFundList(params1, types1);
      const params2 = {
        Fund: this.state.fund.value.value,
        SubAgentCd: !!this.state.subArnCode.value
          ? `ARN-${this.state.subArnCode.value}`
          : "",
        AgentCd: this.state.arnCode.value,
      };
      const brokerresponse = await this.props.validateSubBroker(params2);
      if (
        !!brokerresponse &&
        !!brokerresponse.DtData &&
        brokerresponse.DtData.length > 0
      ) {
        const getLength = brokerresponse.DtData.length === 1;
        if (!!getLength) {
          this.setState({
            euinNo: { value: brokerresponse.DtData[0].abm_agent },
          });
        }
      }
    }
    this.setState({
      display: false,
    });
  }

  handleChange = (label) => async (value) => {
    if (label == "fund") {
      const finalArray = this.state.funds.map(function (obj) {
        return obj.Fund;
      });
      for (let i = 0; i < finalArray.length; i++) {
        if (finalArray[i] == value.value) {
          // const folio = this.props.fundList.reduce((prev, curr) => {
          //   if ( curr.Fund === value.value) {
          //     return [...prev, curr.Acno];
          //   }
          //   return prev;
          // }, []);
          // console.log(folio)
          const message = `There is an existing Folio available in ${value.label}. Do you want to create a New Folio?`;
          this.setState({
            open: true,
            messageAlert: message,
          });
        }
      }
    }
    // if(!!value && !!value.value && (String(value.value).trim() === "176" || String(value.value).trim() === "103")){
    //   this.setState({
    //     PosterOpen:true
    //   })
    // }
    this.setState({ [label]: { value } });
    if (!value) {
      this.setState({
        [label]: { value: "" },
        category: { value: "" },
        scheme: { value: "" },
        minCost: "",
        euinNo: { value: "" },
        showSmart: false,
      });
    } else if (value.value === this.state.fund.value.value) {
      return;
    } else {
      // this.setState({
      //   display:true
      // })
      // if(this.state.fund.value === funds))
      let params = { plntype: REGULAR };
      params = { ...params, opt: "AT", fund: value.value };
      const types = [
        GET_CATEGORY_LIST,
        GET_CATEGORY_LIST_SUCCESS,
        GET_CATEGORY_LIST_FAILED,
      ];
      const response = await this.props.getNewPurchaseFundList(params, types);

      if (response) {
        this.setState({
          [label]: { value },
          category: { value: "" },
          scheme: { value: "" },
          minCost: "",
          euinNo: { value: "" },
          showSmart: false,
        });
      }
      // this.setState({
      //   display:false
      // })
    }
  };

  closePoster = () => {
    this.setState({
      PosterOpen: false,
    });
  };

  validateBrokerCode = async () => {
    if (
      !!this.state.subArnCode.value &&
      this.state.subArnCode.value === this.state.arnCode.value.split("-")[1]
    ) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: "ARN and Sub ARN Code should not be the same",
        },
      });
      return;
    }

    const { fund, subArnCode, arnCode } = this.state;
    const params = {
      Fund: fund.value.value,
      SubAgentCd: !!subArnCode.value ? `ARN-${subArnCode.value}` : "",
      AgentCd: arnCode.value,
    };
    await this.props.validateSubBroker(params);
  };

  handleCategoryChange = (label) => async (event) => {
    this.setState({ [label]: { value: event.target.value } });
    if (!!event.target.value) {
      this.setState({
        display: true,
      });
      let params = { plntype: REGULAR };
      params = {
        ...params,
        opt: "S",
        schemetype: event.target.value,
        fund: this.state.fund.value.value,
      };
      const types = [
        GET_SCHEME_LIST,
        GET_SCHEME_LIST_SUCCESS,
        GET_SCHEME_LIST_FAILED,
      ];
      const response = await this.props.getNewPurchaseFundList(params, types);
      if (response) {
        this.setState({
          [label]: { value: event.target.value },
          scheme: { value: "" },
          minCost: "",
          showSmart: false,
        });
      }
      this.setState({
        display: false,
      });
    } else {
      this.setState({
        [label]: { value: event.target.value },
        scheme: { value: "" },
        minCost: "",
        showSmart: false,
      });
    }
  };

  changeScheme = (value) => {
    let checkCombo, comboScheme;
    if (!!value) {
      comboScheme = this.props.schemeList.find(
        (ele) => ele.Scheme_Plan === value.value
      );
      checkCombo =
        !!comboScheme &&
        !!comboScheme.combo_flag &&
        comboScheme.combo_flag === "Y";
    }
    this.setState({
      scheme: { value: value },
      minCost: !!value ? comboScheme.MinAmt : "",
      isCombo: !!checkCombo ? true : false,
      combo: {
        flag: !!checkCombo ? "Y" : "N",
        disclamier: !!value ? comboScheme.combo_disclaimer : "",
        label: !!value ? comboScheme.combo_lable : "",
      },
      minAmount: { value: "" },
      showSmart: false,
    });
    if (!!value) {
      this.validateBrokerCode();
    }
  };

  changeValue = (label) => (event) => {
    if (label === "minAmount" && event.target.value.length <= 10) {
      this.setState({
        [label]: { value: event.target.value.replace(/^0+/, "") },
      });
    } else if (label === "reference_Number") {
      if (!/^[sS]\d{8}$/.test(event.target.value)) {
        this.setState({
          [label]: {
            value: event.target.value,
            isError: true,
            errorMessage: "Enter a Valid Reference Number",
          },
        });
      } else {
        this.setState({
          [label]: { value: event.target.value },
        });
      }
    } else if (label === "radioValueforpayment") {
      this.setState({
        radioValueforpayment: { value: event.target.value },
      });
    } else if (label === "mobile") {
      this.setState({
        [label]: { value: event.target.value },
      });
    } else if (
      (label === "subArnCode" || label === "subBrokerCode") &&
      event.target.value.length <= 20
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
      return;
    } else if (
      label !== "mobile" &&
      label !== "minAmount" &&
      label !== "subArnCode" &&
      label !== "subBrokerCode"
    ) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
    const value = event.target.value;
    if (label === "code") {
      if (!value) {
        this.setState({
          [label]: {
            value,
            isError: true,
            errorMessage: "Country Code is Mandatory",
          },
        });
      } else if (!/^[+]\d{1,3}$/.test(value)) {
        this.setState({
          [label]: {
            value,
            isError: true,
            errorMessage: "Enter a Valid Country Code",
          },
        });
      } else {
        this.setState({
          [label]: { value },
        });
      }
    }
  };

  changeEuin = (label) => (value) => {
    this.setState({
      [label]: { value },
    });
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    if (label === "minAmount") {
      if (this.state.minCost > this.state.minAmount.value) {
        this.setState({
          [label]: {
            value,
            isError:
              this.state.minCost > this.state.minAmount.value ? true : !value,
            errorMessage:
              this.state.minCost > this.state.minAmount.value
                ? `(Amount should be ${this.state.minCost})`
                : "",
          },
        });
      }
    }
    if (label === "emailId") {
      this.setState({
        [label]: {
          value,
          isError:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.emailId.value
            ) === false
              ? true
              : !value,
          errorMessage:
            /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
              this.state.emailId.value
            ) === false
              ? `( *enter an vaild email address )`
              : "",
        },
      });
    }
    if (label === "mobile") {
      if (
        !/^[6-9]\d{9}$/.test(this.state.mobile.value) &&
        this.state.code.value === "+91"
      ) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Enter a valid Phone Number",
          },
        });
      } else if (!this.state.mobile.value) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Enter a valid Phone Number",
          },
        });
      }
      return;
    }
    if (label === "reference_Number") {
      if (!/^[sS]\d{8}$/.test(value)) {
        this.setState({
          [label]: {
            value: "",
            isError: true,
            errorMessage: "Reference Number should not be more than 8",
          },
        });
      } else {
        this.setState({
          [label]: { value },
        });
      }
    } else {
      this.setState({
        [label]: {
          value,
          isError: !value,
        },
      });
    }
  };
  euinitem = (item) => {
    this.setState({
      euinNo: { value: item },
      openeuin: false,
    });
  };
  FamilyDescriptionEmail = (event) => {
    this.setState({
      Family_Code_Email: { value: event },
    });
  };
  FamilyDescriptionPhone = (event) => {
    this.setState({
      Family_Code_Phone: { value: event },
    });
  };
  yes = () => {
    this.setState({
      open: false,
      existingfolioflag: "Y",
    });
  };
  no = () => {
    this.setState({
      open: false,
      existingfolioflag: "N",
    });
    this.props.history.push({
      pathname: NEW_TRANSACTION_URL + "/additional-purchase/digital/transact",
    });
  };

  onButtonClick = async (btnLabel) => {
    const { location } = this.props;
    const { state } = location;
    const {
      messageAlert,
      existingfolioflag,
      open,
      openDialog,
      funds,
      arnCode,
      radioValueforpayment,
      reference_Number,
      combo,
      erroreuin,
      subArnCode,
      isCombo,
      radioValue,
      invName,
      euinNo,
      minCost,
      openeuin,
      subBrokerCode,
      showSmart,
      smart,
      PosterOpen,
      display,
      code,
      Family_Code_Email,
      Family_Code_Phone,
      emailId,
      ...others
    } = this.state;
    const arn = this.state.arnCode.value.split("-");
    if (this.state.invName.value === "") {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor Name is Mandatory*",
        },
      });
    }
    if (
      !this.state.reference_Number.value &&
      this.state.fund.value.value === "178" &&
      this.props.token === "ARN-35783" &&
      this.state.radioValueforpayment.value === "Y"
    ) {
      this.setState({
        reference_Number: {
          value: "",
          isError: true,
          errorMessage: "Reference Number is mandatory*",
        },
      });
      return;
    }
    if (
      this.state.fund.value.value === "178" &&
      this.props.token === "ARN-35783" &&
      !/^[sS]\d{8}$/.test(this.state.reference_Number.value) &&
      this.state.radioValueforpayment.value === "Y"
    ) {
      this.setState({
        reference_Number: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid reference number*",
        },
      });
      return;
    }
    if (!this.state.mobile.value) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      // this.mobileField.focus();
      return;
    } else if (
      !/^[6-9]\d{9}$/.test(this.state.mobile.value) &&
      this.state.code.value === "+91"
    ) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      // this.mobileField.focus();
      return;
    }
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${key} is mandatory*`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "emailId": {
          // this.emailIdField.focus();
          break;
        }
        case "mobile": {
          this.mobileField.focus();
          break;
        }
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "category": {
          this.categoryField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "minAmount": {
          this.minAmountField.focus();
          break;
        }
      }
      return;
    } else if (invName.value === "") {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor Name is Mandatory",
        },
      });
      return;
    } else if (radioValue.value === "no" && !euinNo.value) {
      this.setState({
        euinNo: {
          value: "",
        },
        erroreuin: true,
      });
      return;
    } else if (minCost > others.minAmount.value) {
      this.setState({
        minAmount: {
          ...others["minAmount"],
          isError: true,
          errorMessage: `(*Amount should be ${minCost})`,
        },
      });
      this.minAmountField.focus();
      return;
    } else if (arn[1] === this.state.subArnCode.value) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should  not match `,
        },
      });
      return;
    }
    if (
      !emailId.value ||
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(emailId.value)
    ) {
      this.setState({
        emailId: {
          ...emailId,
          isError: true,
          errorMessage: "Please enter an valid Email",
        },
      });
      // this.emailField.focus();
      return;
    }
    if (!this.state.code.value) {
      this.setState({
        code: {
          value: "",
          isError: true,
          errorMessage: "Country Code is mandatory*",
        },
      });
      return;
    } else if (!/^[+]\d{1,3}$/.test(this.state.code.value)) {
      this.setState({
        code: {
          value: "",
          isError: true,
          errorMessage: "Enter a Valid Country Code",
        },
      });
      return;
    } else {
      this.setState({
        display: true,
      });
      const plan = this.state.scheme.value.value.split("~");
      const params = {
        investorName: this.state.invName.value,
        pan: this.props.investorData.PAN || state.pan || this.props.user_pan,
        mobile: this.state.mobile.value,
        familyMobileFlag: this.state.Family_Code_Phone.value.value,
        email: this.state.emailId.value,
        familyEmailFlag: this.state.Family_Code_Email.value.value,
        fund: this.state.fund.value.value,
        scheme: plan[1],
        plan: plan[2],
        option: plan[3],
        amount: this.state.minAmount.value,
        arnCode: this.state.arnCode.value,
        subArn: !!this.state.subArnCode.value ? subArnCode.value : "",
        subBroker: this.state.subBrokerCode.value,
        euin: this.state.radioValue.value === "no" ? this.state.euinNo.key : "",
        euinDeclaration: this.state.radioValue.value === "no" ? NO : YES,
        userId: this.state.arnCode.value,
        transactionType: singleTransaction.NEW_PURCHASE_LUMPSUM,
        dcr: singleTransaction.DCR, //Imp
        schemeName: this.state.scheme.value.label,
        category: this.state.category.value,
      };

      if (btnLabel === SUBMIT) {
        this.props.history.replace(
          "/new-investor-transaction/investor-details",
          {
            requestBody: params,
            isCart: false,
            isSingle: true,
            pan:
              this.props.investorData.PAN || state.pan || this.props.user_pan,
            transactionType: "NPL",
          }
        );
        return;
      } else if (btnLabel === addToCart) {
        const response = await this.props.addItemsToCart(params);
        if (response) {
          this.setState({ openDialog: true });
        }
      }

      this.setState({
        display: false,
      });
    }
  };

  ComboChange = () => {
    this.setState({
      isCombo: !this.state.isCombo,
    });
  };
  submit = async () => {
    const { location } = this.props;
    const { state } = location;
    const {
      messageAlert,
      existingfolioflag,
      open,
      funds,
      arnCode,
      radioValueforpayment,
      reference_Number,
      combo,
      erroreuin,
      subArnCode,
      isCombo,
      radioValue,
      invName,
      euinNo,
      minCost,
      openeuin,
      subBrokerCode,
      showSmart,
      smart,
      PosterOpen,
      display,
      code,
      Family_Code_Email,
      Family_Code_Phone,
      emailId,
      ...others
    } = this.state;
    const arn = this.state.arnCode.value.split("-");
    if (this.state.invName.value === "") {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor Name is Mandatory*",
        },
      });
    }
    if (
      !this.state.reference_Number.value &&
      this.state.fund.value.value === "178" &&
      this.props.token === "ARN-35783" &&
      this.state.radioValueforpayment.value === "Y"
    ) {
      this.setState({
        reference_Number: {
          value: "",
          isError: true,
          errorMessage: "Reference Number is mandatory*",
        },
      });
      return;
    }
    if (
      this.state.fund.value.value === "178" &&
      this.props.token === "ARN-35783" &&
      !/^[sS]\d{8}$/.test(this.state.reference_Number.value) &&
      this.state.radioValueforpayment.value === "Y"
    ) {
      this.setState({
        reference_Number: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid reference number*",
        },
      });
      return;
    }
    if (!this.state.mobile.value) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      // this.mobileField.focus();
      return;
    } else if (
      !/^[6-9]\d{9}$/.test(this.state.mobile.value) &&
      this.state.code.value === "+91"
    ) {
      this.setState({
        mobile: {
          value: "",
          isError: true,
          errorMessage: "Enter a valid phone number",
        },
      });
      // this.mobileField.focus();
      return;
    }
    const keys = Object.keys(others);
    const findError = keys.every((key) => !!others[key].value);
    if (!findError) {
      keys.forEach((key) => {
        !others[key].value &&
          this.setState({
            [key]: {
              ...others[key],
              isError: true,
              errorMessage: `${key} is mandatory*`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !others[key].value);
      switch (firstErroredKey) {
        case "emailId": {
          // this.emailIdField.focus();
          break;
        }
        case "mobile": {
          this.mobileField.focus();
          break;
        }
        case "fund": {
          this.fundField.focus();
          break;
        }
        case "category": {
          this.categoryField.focus();
          break;
        }
        case "scheme": {
          this.schemeField.focus();
          break;
        }
        case "minAmount": {
          this.minAmountField.focus();
          break;
        }
      }
      return;
    } else if (invName.value === "") {
      this.setState({
        invName: {
          value: "",
          isError: true,
          errorMessage: "Investor Name is Mandatory",
        },
      });
      return;
    } else if (radioValue.value === "no" && !euinNo.value) {
      this.setState({
        euinNo: {
          value: "",
        },
        erroreuin: true,
      });
      return;
    } else if (minCost > others.minAmount.value) {
      this.setState({
        minAmount: {
          ...others["minAmount"],
          isError: true,
          errorMessage: `(*Amount should be ${minCost})`,
        },
      });
      this.minAmountField.focus();
      return;
    } else if (arn[1] === this.state.subArnCode.value) {
      this.setState({
        subArnCode: {
          value: "",
          isError: true,
          errorMessage: `and ARN code should  not match `,
        },
      });
      return;
    }
    if (
      !emailId.value ||
      !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(emailId.value)
    ) {
      this.setState({
        emailId: {
          ...emailId,
          isError: true,
          errorMessage: "Please enter an valid Email",
        },
      });
      // this.emailField.focus();
      return;
    }
    if (!this.state.code.value) {
      this.setState({
        code: {
          value: "",
          isError: true,
          errorMessage: "Country Code is mandatory*",
        },
      });
      return;
    } else if (!/^[+]\d{1,3}$/.test(this.state.code.value)) {
      this.setState({
        code: {
          value: "",
          isError: true,
          errorMessage: "Enter a Valid Country Code",
        },
      });
      return;
    } else {
      this.setState({
        display: true,
      });
      const plan = this.state.scheme.value.value.split("~");
      const params = {
        InvestorName: this.state.invName.value,
        i_entby: this.props.userId,
        trtype: PURCHASE,
        Desci: "Yes~A~",
        SubbrokerArn: !!this.state.subArnCode.value ? subArnCode.value : "",
        ARNCode: this.state.arnCode.value,
        EuinCode:
          this.state.radioValue.value === "no" ? this.state.euinNo.value : "",
        i_Userid: this.props.userId,
        Mobile: this.state.mobile.value,
        countrycode: this.state.code.value,
        PanNo: this.props.investorData.PAN || state.pan || this.props.user_pan,
        Email: this.state.emailId.value,
        fEmailFlag: this.state.Family_Code_Email.value.value,
        fMobileFlag: this.state.Family_Code_Phone.value.value,
        i_Acno: "0",
        Subbroker: this.state.subBrokerCode.value,
        i_Fund: this.state.fund.value.value,
        i_UntAmtValue: this.state.minAmount.value,
        EUINFlag: this.state.radioValue.value === "no" ? NO : YES,
        EuinValid: this.state.radioValue.value === "no" ? NO : YES,
        i_Scheme: plan[1],
        i_Plan: plan[2],
        i_Option: plan[3],
        i_oldihno: "0",
        i_InvDistFlag: "W",
        ModuleName: "Webile",
        bob_pio_flag: this.state.radioValueforpayment.value,
        bob_pio_refno: this.state.reference_Number.value,
        NewFolioConsists: this.state.existingfolioflag,
      };

      const response = await this.props.submitPurchaseData(params);
      if (response) {
        const {
          DtData: [purchaseData],
        } = response;
        const confirmationParams = {
          Trtype: PURCHASE,
          fund: this.state.fund.value.value,
          Refno: purchaseData.refno,
          ModuleName: "Webile",
        };
        const confirmationResponse = await this.props.showPurchaseConfirmation(
          confirmationParams
        );

        if (confirmationResponse) {
          this.props.history.push({
            pathname:
              NEW_TRANSACTION_URL +
              "/nfo-new-purchase/digital/transact/confirm",
            state: {
              title: "NEW PURCHASE SUMMARY",
              pan: !!state && !!state.pan ? state.pan : "",
              InvestorEmail: this.state.emailId.value,
              countrycode: this.state.code.value,
              fEmailFlag: this.state.Family_Code_Email.value.value,
              fMobileFlag: this.state.Family_Code_Phone.value.value,
              InvestorMobile: this.state.mobile.value,
              scheme: { Fund: this.state.fund.value.value },
              type: NEW_PURCHASE,
              arnCode: this.state.arnCode.value,
              bob_pio_flag: this.state.radioValueforpayment.value,
              bob_pio_refno: this.state.reference_Number.value,
              displayBOP:
                this.state.fund.value.value === "178" &&
                this.props.token === "ARN-35783",
            },
          });
        }
      }
      this.setState({
        display: false,
      });
    }
  };

  ComboChange = () => {
    this.setState({
      isCombo: !this.state.isCombo,
    });
  };

  changeSmart = (event) => {
    this.setState({
      smart: { flag: event.target.value },
    });
  };

  render() {
    const { fundsList, schemeList, categoryList, euinList } = this.props;
    const {
      reference_Number,
      emailId,
      radioValueforpayment,
      mobile,
      arnCode,
      fund,
      invName,
      category,
      combo,
      scheme,
      subArnCode,
      radioValue,
      euinNo,
      minAmount,
      subBrokerCode,
      isCombo,
      display,
      Family_Code_Email,
      Family_Code_Phone,
    } = this.state;
    const { location } = this.props;
    console.log(this.state.isCombo);
    return (
      <React.Fragment>
        <CustomLoader display={!!display} />
        {/* <PosterDialog open={this.state.PosterOpen} close={this.closePoster} /> */}
        <div className="transaction-details">
          <div className="title">New Purchase</div>

          {/* {!!state && !!state.pan && ( */}
          <div className="input-margin">
            <Input
              name="Investor Name"
              value={invName.value}
              onChange={this.changeValue("invName")}
              onBlur={this.showError("invName")}
              errorMessage={invName.errorMessage}
              isShowError={invName.isError}
              disabled={!!location.state.transaction ? true : false}
              inputref={(ele) => (this.invNameField = ele)}
            />
          </div>
          <div className="input-margin">
            <div className="input-name input-integrated-label">
              Email Family Description
            </div>
            <IntegrationReactSelect
              suggestions={family_description_code.map((item) => ({
                label: item.family_description,
                value: item.family_code,
              }))}
              value={Family_Code_Email.value}
              placeholder="Select Family Description"
              handleChange={this.FamilyDescriptionEmail}
              disabled={!!location.state.transaction ? true : false}
            />
          </div>
          <div className="input-margin">
            <Input
              name="Email ID"
              value={emailId.value}
              // disabled={!!location.state.transaction ? true : false}
              bordercolor="#a6a6a6"
              onChange={this.changeValue("emailId")}
              onBlur={this.showError("emailId")}
              isShowError={emailId.isError}
              inputref={(ele) => (this.emailIdField = ele)}
              errorMessage={this.state.emailId.errorMessage}
            />
          </div>
          <div className="input-margin">
            <div className="input-name input-integrated-label">
              Mobile Family Description
            </div>
            <IntegrationReactSelect
              suggestions={family_description_code.map((item) => ({
                label: item.family_description,
                value: item.family_code,
              }))}
              value={Family_Code_Phone.value}
              placeholder="Select Phone Description"
              handleChange={this.FamilyDescriptionPhone}
              disabled={!!location.state.transaction ? true : false}
            />
          </div>
          <div className="input-margin">
            <Input
              name="Country Code"
              value={this.state.code.value}
              onKeyDown={(evt) => {
                if (evt.key === "e" || evt.key === "." || evt.key === "-") {
                  evt.preventDefault();
                }
              }}
              onChange={this.changeValue("code")}
              isError={this.state.code.isError}
              isShowError={this.state.code.isError}
              errorMessage={this.state.code.errorMessage}
              inputref={(ele) => (this.countryCodeField = ele)}
              disabled={!!location.state.transaction ? true : false}
            />
          </div>
          <div className="input-margin">
            <Input
              name="Phone No"
              type="number"
              bordercolor="#a6a6a6"
              onKeyDown={(evt) =>
                (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                evt.preventDefault()
              }
              value={mobile.value}
              onChange={this.changeValue("mobile")}
              onBlur={this.showError("mobile")}
              isShowError={mobile.isError}
              errorMessage={mobile.errorMessage}
              inputref={(ele) => (this.mobileField = ele)}
              disabled={!!location.state.transaction ? true : false}
            />
          </div>

          <div className="input-margin">
            <div className="input-name input-integrated-label">AMC</div>
            <IntegrationReactSelect
              suggestions={fundsList.map((item) => ({
                label: item.amc_name,
                value: item.amc_code,
              }))}
              value={fund.value}
              placeholder="Select AMC"
              handleChange={this.handleChange("fund")}
              inputRef={(ele) => (this.fundField = ele)}
              isError={fund.isError}
              errorMessage={fund.errorMessage}
            />
          </div>
          <div className="input-margin">
            <CustomizedSelect
              name="Category"
              borderColor="#a6a6a6"
              handleChange={this.handleCategoryChange("category")}
              value={category.value}
              placeholder="Select Category"
              disabled={!fund.value}
              inputRef={(ele) => (this.categoryField = ele)}
              isError={category.isError}
              errorMessage={category.errorMessage}
            >
              {categoryList.map((item, index) => (
                <MenuItem value={item.fm_subcategory} key={index}>
                  {item.fm_subcategory}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>

          <div className="input-margin">
            <div className="input-name input-integrated-label">Scheme</div>
            <IntegrationReactSelect
              suggestions={schemeList.map((item) => ({
                label: item.Scheme_Desc,
                value: item.Scheme_Plan,
              }))}
              value={scheme.value}
              placeholder="Select Scheme"
              handleChange={this.changeScheme}
              disabled={!category.value}
              inputRef={(ele) => (this.schemeField = ele)}
              isError={scheme.isError}
              errorMessage={scheme.errorMessage}
            />
          </div>

          <div className="input-margin">
            <Input
              name={`Investment Amount ${
                this.state.minCost
                  ? `(minimum : ${this.state.minCost} INR)`
                  : ""
              }`}
              bordercolor="#a6a6a6"
              onKeyDown={(evt) =>
                (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                evt.preventDefault()
              }
              placeholder="Amount"
              step="1"
              type="number"
              value={minAmount.value}
              onChange={this.changeValue("minAmount")}
              onBlur={this.showError("minAmount")}
              errorMessage={minAmount.errorMessage}
              isShowError={minAmount.isError}
              inputref={(ele) => (this.minAmountField = ele)}
            />
          </div>

          <div className="input-margin">
            <Input
              name="ARN Code"
              bordercolor="#a6a6a6"
              value={arnCode.value.split("-")[1]}
              disabled={true}
            />
          </div>

          <div className="input-margin">
            <Input
              name="Sub ARN Code"
              onKeyDown={(evt) =>
                (evt.key === "e" || evt.key === "." || evt.key === "-") &&
                evt.preventDefault()
              }
              bordercolor="#a6a6a6"
              type="number"
              value={subArnCode.value}
              isShowError={subArnCode.isError}
              errorMessage={subArnCode.errorMessage}
              onBlur={this.validateBrokerCode}
              onChange={this.changeValue("subArnCode")}
              disabled={!!location.state.transaction ? true : false}
              inputref={(ele) => (this.subArnField = ele)}
            />
          </div>

          <div className="input-margin">
            <Input
              name="Sub Broker Code"
              onKeyDown={(evt) =>
                (evt.key === "." || evt.key === "-") && evt.preventDefault()
              }
              bordercolor="#a6a6a6"
              value={subBrokerCode.value}
              onChange={this.changeValue("subBrokerCode")}
              inputref={(ele) => (this.subBrokerField = ele)}
              disabled={!!location.state.transaction ? true : false}
            />
          </div>
          <div className="input-field-container ">
            <div className="input-name" style={{ marginBottom: 0 }}>
              EUIN
            </div>

            <FormControl component="fieldset">
              <RadioGroup
                aria-label="Search"
                name="search"
                value={radioValue.value}
                style={{ flexDirection: "row" }}
                onChange={this.changeValue("radioValue")}
              >
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="yes"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">YES</div>
                </div>
                <div className="investor-radio-button">
                  <FormControlLabel
                    value="no"
                    control={
                      <Radio
                        className="investor-search-radio"
                        style={{ color: "#007ac8" }}
                      />
                    }
                    className="investor-formcontrol-label"
                    style={{ margin: 0 }}
                  />
                  <div className="investor-form-label">NO</div>
                </div>
              </RadioGroup>
            </FormControl>
          </div>
          {radioValue.value === "no" ? (
            // <div className="input-margin input-select-responsive">
            //   <IntegrationReactSelect
            //     suggestions={euinList.map((item) => ({
            //       label: item.abm_agent,
            //       value: item.abm_agent,
            //     }))}
            //     value={euinNo.value}
            //     placeholder="Select EUIN"
            //     handleChange={this.changeEuin("euinNo")}
            //     errorMessage={euinNo.errorMessage}
            //     disabled={!euinList.length}
            //     inputRef={(ele) => (this.euinField = ele)}
            //     isError={euinNo.isError}
            //   />
            // </div>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: 15,
                }}
              >
                <div
                  className="investor-input-div"
                  style={{ border: "1px black solid", height: "50px" }}
                >
                  <SearchIcon className="investor-input-searchicon" />
                  <InputBase
                    value={euinNo.value}
                    placeholder="Type here"
                    className="investor-input-inputbase"
                    onChange={(e) =>
                      this.setState({
                        euinNo: { value: e.target.value },
                        openeuin: true,
                      })
                    }
                  />
                </div>
              </div>
              {euinList.length > 0 && this.state.openeuin && (
                <div className="dataResult">
                  {euinList &&
                    euinList
                      .filter((ele) =>
                        ele.abm_agent
                          .toLowerCase()
                          .includes(euinNo.value.toLowerCase())
                      )
                      .map((ele) => (
                        <div>
                          <p
                            onClick={() => this.euinitem(ele.abm_agent)}
                            className="euin-item"
                          >
                            {ele.abm_agent}
                          </p>
                        </div>
                      ))}
                </div>
              )}
              {this.state.erroreuin && !this.state.euinNo.value && (
                <div style={{ color: "red" }}>
                  Euin Declaration is mandatory
                </div>
              )}
            </div>
          ) : (
            <div className="euin-text">
              I/We hereby confirm that the EUIN box has been intentionally left
              the blank by me/us as this is an 'execution-only' transaction
              without any interaction or advice by any personnel of the above
              distributor or notwithstanding the advice of in-appropriateness,if
              any provided by any personnel of the distributor and the
              distributor has not charged any advisory fees on this transaction
            </div>
          )}

          {combo.flag === "Y" && (
            <div
              style={{ display: "flex", alignItems: "center", marginTop: 10 }}
            >
              <Checkbox
                onClick={this.ComboChange}
                value={combo.label}
                checked={isCombo}
                color="secondary"
              />
              <div
                style={{
                  fontSize: 14,
                  fontFamily: "OpenSans-Bold",
                  color: "#283d7c",
                }}
              >
                {combo.label}
              </div>
            </div>
          )}

          {combo.flag === "Y" && (
            <div
              style={{
                color: "#283d7c",
                fontSize: 14,
                fontFamily: "OpenSans-SemiBold",
                margin: 10,
              }}
            >
              {combo.disclamier}
            </div>
          )}
          {this.props.token === "ARN-35783" &&
            this.state.fund.value.value === "178" && (
              <div>
                <div
                  className="input-margin "
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: 15,
                  }}
                >
                  <span style={{ paddingTop: 12 }}>
                    BOB-PIO Payment Option:
                  </span>
                  <FormControl component="fieldset">
                    <RadioGroup
                      aria-label="Search"
                      name="search"
                      style={{ flexDirection: "row" }}
                      value={radioValueforpayment.value}
                      onChange={this.changeValue("radioValueforpayment")}
                    >
                      <div className="investor-radio-button">
                        <FormControlLabel
                          value="Y"
                          control={
                            <Radio
                              className="investor-search-radio"
                              style={{ color: "#007ac8" }}
                            />
                          }
                          className="investor-formcontrol-label"
                          style={{ margin: 0 }}
                        />
                        <div className="investor-form-label">Yes</div>
                      </div>
                      <div className="investor-radio-button">
                        <FormControlLabel
                          value="N"
                          control={
                            <Radio
                              className="investor-search-radio"
                              style={{ color: "#007ac8" }}
                            />
                          }
                          className="investor-formcontrol-label"
                          style={{ margin: 0 }}
                        />
                        <div className="investor-form-label">No</div>
                      </div>
                    </RadioGroup>
                  </FormControl>
                </div>
                {this.state.radioValueforpayment.value === "Y" && (
                  <div style={{ marginBottom: 20 }}>
                    <Input
                      name="Payment (pre-debit) Reference Number "
                      bordercolor="#a6a6a6"
                      placeholder="Enter the Reference Number"
                      value={reference_Number.value}
                      isShowError={reference_Number.isError}
                      errorMessage={reference_Number.errorMessage}
                      onChange={this.changeValue("reference_Number")}
                    />
                  </div>
                )}
              </div>
            )}
          {this.props.isCartUser ? (
            <div className="trantype-button-view">
              <Signbutton
                buttontitle="Add to cart"
                onClick={() => this.onButtonClick(`${addToCart}`)}
                width={240}
                border={"1px solid #007CC5"}
                texttransform={true}
              />
              <span className="addtocart-btn" />
              <Signbutton
                buttontitle="Submit"
                onClick={() => this.onButtonClick(`${SUBMIT}`)}
                width={240}
                border={"1px solid #007CC5"}
                texttransform={true}
              />
            </div>
          ) : (
            <div className="digital-form-button-next-div">
              <Signbutton buttontitle="Submit" onClick={this.submit} />
            </div>
          )}

          <AddToCartStatusModal
            message={"Item added to Cart Successfully"}
            closeModal={this.close}
            open={this.state.openDialog}
            image={"/images/cart_success.svg"}
            btn_one={"Go to cart"}
            btn_two={"Add more"}
            history={this.props.history}
            pan={
              this.props.investorData.PAN ||
              this?.props?.location?.state.pan ||
              this.props.user_pan
            }
            onAddTransaction={() =>
              this.props.history.push("/cart/add-transaction/new-purchase", {
                pan: this.props.investorData.PAN,
              })
            }
          />
          {/* <NewPurchaseFolioDialog
            message={this.state.messageAlert}
            open={this.state.open}
            yes={this.yes}
            no={this.no}
          /> */}
        </div>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ authReducer, transactions }) => {
    const {
      fundList,
      investorData,
      communicationDetails,
      token,
      userId,
      user_pan,
    } = authReducer;
    const { fundsList, schemeList, categoryList, euinList } = transactions;
    return {
      fundList,
      investorData,
      communicationDetails,
      token,
      fundsList,
      schemeList,
      categoryList,
      euinList,
      userId,
      user_pan,
    };
  },
  {
    getNewPurchaseFundList,
    getInvestorDetails,
    validateSubBroker,
    submitPurchaseData,
    showPurchaseConfirmation,
  }
)(NewPurchase);

// {!!showSmart && (
//   <div className="input-field-container">
//     <div
//       className="input-name"
//       style={{ fontFamily: "OpenSans-SemiBold", fontSize: 16 }}
//     >
//       Your investor is eligible for a SMART facility
//     </div>

//     <FormControl component="fieldset">
//       <RadioGroup
//         aria-label="Search"
//         name="search"
//         value={smart.flag}
//         style={{ flexDirection: "row" }}
//         onChange={this.changeSmart}
//       >
//         <div className="investor-radio-button">
//           <FormControlLabel
//             value="yes"
//             control={
//               <Radio
//                 className="investor-search-radio"
//                 style={{ color: "#007ac8" }}
//               />
//             }
//             className="investor-formcontrol-label"
//             style={{ margin: 0 }}
//           />
//           <div className="investor-form-label">YES</div>
//         </div>
//         <div className="investor-radio-button">
//           <FormControlLabel
//             value="no"
//             control={
//               <Radio
//                 className="investor-search-radio"
//                 style={{ color: "#007ac8" }}
//               />
//             }
//             className="investor-formcontrol-label"
//             style={{ margin: 0 }}
//           />
//           <div className="investor-form-label">NO</div>
//         </div>
//       </RadioGroup>
//     </FormControl>
//   </div>
// )}
